'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 -7.62939e-06C9.33333 8.3077e-05 18.6667 1.07288e-06 28 1.07288e-06C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20.0001 0 20V-7.62939e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20L28 20V1.07288e-06L0 -7.62939e-06V20Z",
          fill: "#079D7B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.8849 8.6667C15.8849 8.95856 15.8637 9.24166 15.8238 9.51144C15.9261 9.48 16.0302 9.45002 16.1361 9.42165C17.9143 8.94518 19.5015 9.10239 19.6811 9.77279C19.8435 10.3787 18.8006 11.1964 17.2858 11.6999C17.0182 10.9062 15.6488 10.6667 13.9998 10.6667C12.349 10.6667 10.9785 10.9067 10.713 11.7025C9.21866 11.198 8.19451 10.3889 8.3555 9.78811C8.53513 9.1177 10.1223 8.96049 11.9005 9.43697C11.9939 9.46198 12.0859 9.48825 12.1765 9.51566C12.1362 9.24461 12.1148 8.96008 12.1148 8.6667C12.1148 6.82575 12.9587 5.33336 13.9998 5.33336C15.0409 5.33336 15.8849 6.82575 15.8849 8.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.833 12C11.6482 11.9638 11.4597 11.9204 11.2689 11.8698C11.4835 11.8761 11.748 11.8945 12.0508 11.9154C12.5989 11.9534 13.2721 12 13.9998 12C14.7275 12 15.4007 11.9534 15.9488 11.9154C16.2402 11.8952 16.4962 11.8775 16.7063 11.8705C16.5088 11.9215 16.314 11.9646 16.1235 12H19.3332C19.175 12.4747 18.9622 12.922 18.7027 13.3334H9.297C9.03748 12.922 8.82463 12.4747 8.66649 12H11.833Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.9996 16C15.3463 16 16.5831 15.5005 17.5544 14.6667H10.4448C11.4161 15.5005 12.6529 16 13.9996 16Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.0002 4.00001C14.3684 4.00001 14.6668 3.70153 14.6668 3.33334C14.6668 2.96515 14.3684 2.66668 14.0002 2.66668C13.632 2.66668 13.3335 2.96515 13.3335 3.33334C13.3335 3.70153 13.632 4.00001 14.0002 4.00001Z",
          fill: "#FCD117"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.66667 7.33334C9.03486 7.33334 9.33333 7.03487 9.33333 6.66668C9.33333 6.29849 9.03486 6.00001 8.66667 6.00001C8.29848 6.00001 8 6.29849 8 6.66668C8 7.03487 8.29848 7.33334 8.66667 7.33334Z",
          fill: "#FCD117"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.9998 6.66666C19.9998 7.03485 19.7014 7.33332 19.3332 7.33332C18.965 7.33332 18.6665 7.03485 18.6665 6.66666C18.6665 6.29847 18.965 5.99999 19.3332 5.99999C19.7014 5.99999 19.9998 6.29847 19.9998 6.66666Z",
          fill: "#FCD117"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3332 5.33332C17.7014 5.33332 17.9998 5.03485 17.9998 4.66666C17.9998 4.29847 17.7014 3.99999 17.3332 3.99999C16.965 3.99999 16.6665 4.29847 16.6665 4.66666C16.6665 5.03485 16.965 5.33332 17.3332 5.33332Z",
          fill: "#FCD117"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.3333 4.66668C11.3333 5.03487 11.0349 5.33334 10.6667 5.33334C10.2985 5.33334 10 5.03487 10 4.66668C10 4.29849 10.2985 4.00001 10.6667 4.00001C11.0349 4.00001 11.3333 4.29849 11.3333 4.66668Z",
          fill: "#FCD117"
        }
      )
    ]
  }
);
const VpFlagMoAsset = forwardRef(FlagMoAsset);

export { VpFlagMoAsset as default };
